/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-01-19 15:04:12
 * @LastEditors: limin
 * @LastEditTime: 2021-04-23 15:25:38
 */
import init from "./index";
import App from "./App.vue";
const isdev = process.env.NODE_ENV == "development";
// 开发环境下面使用vConsole进行调试
// if (!isdev) {
  // const VConsole = require("vconsole");
  // new VConsole();
// }
init().then(({ Vue, router, store, subscribe, unsubscribe }) => {
  window.vm = new Vue({
    sockets: {
      connect() {
        subscribe();
        //window.vm.$socket.emit('exchange',{'toAppId':'h5_wxc0e73a3d0afbcb06_238928390sdjaskd',target:'onMessageFromPayBack',payload:{aaa:1111}})
      },
      disconnect() {
        unsubscribe();
      }
    },
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
});
